// Components
import { SidebarTrigger } from "@/components/common/sidebar";
// import ThemeButton from "@/components/page-specific/Navbar/ThemeButton";

export default function Navbar() {
  return (
    <header className="text-foreground flex h-16 shrink-0 items-center gap-2 transition-[width,height] ease-linear group-has-[[data-collapsible=icon]]/sidebar-wrapper:h-12">
      <div className="flex w-full items-center justify-between gap-2 px-4 lg:px-6">
        <div className="flex items-center gap-2">
          <SidebarTrigger className="-ml-1" />
        </div>
        {/* <ThemeButton /> */}
      </div>
    </header>
  );
}
